import { render } from "./InputEntity.vue?vue&type=template&id=1c9a22d9"
import script from "./InputEntity.vue?vue&type=script&lang=js"
export * from "./InputEntity.vue?vue&type=script&lang=js"

import "./InputEntity.vue?vue&type=style&index=0&id=1c9a22d9&lang=scss"
script.render = render

export default script